export default __webpack_public_path__ + "static/media/Sash of the Amaranthine Drums.def97323.jpg";